import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import {
  OpenEditSessionResponseSchema,
  OpenEditSessionResponseType,
} from '../../../edit-session/schema/EditSessionSchema';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

const openInputDataEditSession = async (params: { scopeKey: string }) =>
  apiClient
    .post<OpenEditSessionResponseType>(InputDataEditSessionUrl.open, params)
    .then((response) => OpenEditSessionResponseSchema.parse(response.data));

export const useInputDataEditSessionQuery = createApiQueryHook(
  ['input-data-edit-session'],
  openInputDataEditSession,
  {
    staleTime: Infinity,
    gcTime: Infinity,
  },
);
